import React from 'react';
import {
    Card,
    ResetPasswordModal,
    ExamApplicationTabs,
} from 'components';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { ExamApplicationStatus } from '../../api/ApiClient';
import { useLocalErrorHandler } from 'hooks';

const ExamApplicationDetailsContainer = ({
    applicationId,
    applicationDetails,
    fetchExamApplicationDetails,
    setErrorHandler,
    apiError,
    setApplicantTempPassword,
}: Props) => {
    const [showPasswordModal, setShowPasswordModal] = React.useState(false);
    const [processing, setProcessing] = React.useState(false);

    useLocalErrorHandler(setErrorHandler);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await fetchExamApplicationDetails(applicationId);
            setProcessing(false);
        };

        fetch();
    }, []);

    const onChangePassword = async ({ newPassword }: IChangePassword) => {
        const applicantId = applicationDetails && applicationDetails.applicant && applicationDetails.applicant.id;

        if (!applicantId) return false;

        const res = await setApplicantTempPassword({ applicantId, body: { newPassword } });

        return !!res;
    };

    const renderExamTabChild = () => (applicationDetails && applicationDetails.status === ExamApplicationStatus.AdmittedToExam ? (
        <>
            <Button className="d-block mt-4" onClick={() => setShowPasswordModal(true)}>Установить временный пароль</Button>
            <ResetPasswordModal
              title="Установить временный пароль"
              show={showPasswordModal}
              onHide={() => setShowPasswordModal(false)}
              apiError={apiError}
              onChangePassword={onChangePassword}
              withoutOldPass
            />
        </>
    ) : null);

    return (
        <Card
          apiError={apiError}
          showLoader={processing}
          cardClassName="p-3"
          show404Error={!applicationDetails}
          withoutPadding
          withBackButton
          withoutBorder
        >
            {applicationDetails ? (
                <ExamApplicationTabs
                  examApplicationDetails={applicationDetails}
                  examTabChild={renderExamTabChild}
                  inModal
                  withoutTabPadding
                />
            ) : null}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    apiError: state.errors.error,
    applicationDetails: state.examApplications.applicationDetails,
});

const mapDispatch = (dispatch: Dispatch) => ({
    fetchExamApplicationDetails: dispatch.examApplications.fetchExamApplicationDetailsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
    setApplicantTempPassword: dispatch.applicants.setApplicantTempPasswordAsync,
});

export default connect(mapState, mapDispatch)(ExamApplicationDetailsContainer);

interface IProps {
    applicationId: string;
}

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps & IProps;

interface IChangePassword {
    newPassword: string;
    oldPassword?: string;
    captcha?: string;
}
